import { useSelector } from 'react-redux';
import {
    getDialogRoutesStatus,
    getRouteDetails,
    getRoutesAsSouceSet,
    getRoutesAsSourceSetForTask,
    getRoutesPaneMode,
    getRoutesSourceSetModel,
    getRoutesStatus,
    getSelectedCategory,
    getSelectedDates,
    getSelectedRoute,
    getSelectedRouteId,
    getSelectedRoutes,
    getSelectedRoutesColors,
    isRoutesPaneVisible,
} from './';

export const useIsRoutesPaneVisible = () => useSelector(isRoutesPaneVisible);
export const useRoutes = () => useSelector(getRoutesAsSouceSet);
export const useDialogRoutesStatus = () => useSelector(getDialogRoutesStatus);

export const useRoutesForTask = () => useSelector(getRoutesAsSourceSetForTask);
export const useRoutesMode = () => useSelector(getRoutesPaneMode);
export const useRoutesSourceSetModel = () =>
    useSelector(getRoutesSourceSetModel);
export const useRoutesStatus = () => useSelector(getRoutesStatus);
export const useSelectedRoute = () => useSelector(getSelectedRoute);
export const useSelectedRouteDetails = () => useSelector(getRouteDetails);

export const useSelectedRouteId = () => useSelector(getSelectedRouteId);

export const useSelectedRoutes = () => useSelector(getSelectedRoutes);
export const useSelectedRoutesColors = () =>
    useSelector(getSelectedRoutesColors);
export const useSelectedCategory = () => useSelector(getSelectedCategory);
export const useSelectedDates = () => useSelector(getSelectedDates);
